/**
 * Uklanja fallback SEO tagove iz `public/index.html`.
 *
 * Zašto uopšte postoje: sajt je CRA SPA bez servera koji renderuje HTML, a
 * Facebook, WhatsApp i Viber ne izvršavaju JavaScript — oni vide samo statični
 * index.html. Zato title/description/OG tagovi moraju da stoje i tamo.
 *
 * Zašto se brišu: react-helmet-async v3 na React-u 19 koristi nativni React
 * metadata hoisting. Za razliku od ranijih verzija, ne prepoznaje i ne zamenjuje
 * zatečene tagove u <head>, već svoje samo dodaje — pa bi bez ovog čišćenja
 * svaka stranica imala dva <title> i dva opisa, a čitači uzimaju prvi.
 */
export const SEO_FALLBACK_ATTRIBUTE = 'data-seo-fallback';

export function dropSeoFallbackTags(doc = document) {
  doc.head.querySelectorAll(`[${SEO_FALLBACK_ATTRIBUTE}]`).forEach((node) => node.remove());
}

export default dropSeoFallbackTags;
